import axios from "axios"

/**
 * Simple function to submit career application using convertedData.values directly
 */
export const submitCareerApplication = async (
  convertedData: any,
  jobId: string,
) => {
  try {
    // Extract values directly from convertedData.values without elaborate transformation
    const values = convertedData?.values || {}
    const applicationData = {
      firstName: values.privateName?.[0] || "",
      lastName: values.lastName?.[0] || "",
      email: values.email?.[0] || "",
      phone: values.phone?.[0] || "",
      orderId: parseInt(jobId, 10),
      fileNameWithExtension: values.cvFileBase64?.[0]?.fileName || "cv.pdf",
      cvFileBase64: values.cvFileBase64?.[0]?.fileContents || "",
    }

    const response = await axios.post("/api/career/apply", applicationData, {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 30000,
    })

    return response.data
  } catch (error) {
    console.error("Error submitting career application:", error)
    throw error
  }
}
